import { ClauseType } from '../../../DocumentView/Constants/ClauseType';

export const CLAUSE_RENDERING_ORDER: ClauseType[] = [
  'term',
  'termination',
  'termination_at_convenience',
  'renewal',
  'governing_law',
  'payment',
  'indemnity',
  'confidentiality',
  'change_of_control',
  'insurance',
  'notice',
  'events_of_default',
  'limited_liability',
  'force_majeure',
  'dispute_resolution',
  'non_compete',
  'non_solicitation',
  'subletting',
  'consent',
  'general_definitions',
  // 'assignment',
  'data_breach',
  // 'effective_date',
  'exclusivity',
  // 'premise',
  'contracting_parties',
  'locked_in_period',
  'obligation_statements',
];
